import { Navigate, Outlet } from 'react-router-dom'

import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import CategoriesMatterPage from './CategoriesMatterPage'
import MainGoalPage from './MainGoalPage'
import MoneyControlPage from './MoneyControlPage'
import MonthlySpendingPage from './MonthlySpendingPage'
import SavingsGoalPage from './SavingsGoalPage'
import SpendSmartPage from './SpendSmartPage'
import TrackSpendingPage from './TrackSpendingPage'
import YourReceiptsPage from './YourReceiptsPage'

const onboardingRoutes = [
  {
    path: '/onboarding',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <Navigate to="main-goal" replace />,
        index: true,
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <MainGoalPage />,
        path: 'main-goal',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <TrackSpendingPage />,
        path: 'track-spending',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <MonthlySpendingPage />,
        path: 'monthly-spending',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <MoneyControlPage />,
        path: 'money-control',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <YourReceiptsPage />,
        path: 'your-receipts',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CategoriesMatterPage />,
        path: 'categories-matter',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SavingsGoalPage />,
        path: 'savings-goal',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SpendSmartPage />,
        path: 'spend-smart',
      },
    ],
  },
]

export default onboardingRoutes
